import { IColumn } from '@fluentui/react';
import { commonColumnProps } from 'common/utils/columnUtilities';

export type ColumnData = IColumn & {
  /** property to determine whether this column can be toggled for visibility */
  toggleVisibility?: boolean;
  /** property to determine whether the column is visible or not*/
  isVisible?: boolean;
  isFormField?: boolean;
};

export const useColumns = () => {
  const columns = new Map<string, ColumnData>([
    [
      'currencyId',
      {
        key: 'currencyId',
        name: 'Currencies',
        fieldName: 'currencyId',
        minWidth: 200,
        maxWidth: 200,
        ...commonColumnProps,
      },
    ],
    [
      'exchangeRate',
      {
        key: 'exchangeRate',
        name: 'Budgeted Rate',
        fieldName: 'exchangeRate',
        minWidth: 180,
        maxWidth: 180,
        ...commonColumnProps,
      },
    ],
    [
      'spotRate',
      {
        key: 'spotRate',
        name: 'Spot Rate',
        fieldName: 'spotRate',
        minWidth: 180,
        maxWidth: 180,
        ...commonColumnProps,
      },
    ],
    [
      'isSpotRatePreferred',
      {
        key: 'isSpotRatePreferred',
        name: 'Spot Preferred',
        fieldName: 'isSpotRatePreferred',
        minWidth: 180,
        maxWidth: 180,
        ...commonColumnProps,
      },
    ],
    [
      'delete',
      {
        key: 'delete',
        name: '',
        fieldName: 'delete',
        minWidth: 80,
        maxWidth: 80,
        ...commonColumnProps,
      },
    ],
  ]);

  let columnArray = Array.from(columns, (data) => data[1]);
  return { columns, columnArray };
};
